import { DashboardComponentPair } from '../../../../models/dashboard';
import { DailyScanTimesDashboardComponent } from './daily-scan-times-dashboard.component';
import { DailyScanTimesDashboardFormComponent } from './daily-scan-times-dashboard-form.component';

export const ComponentPair: DashboardComponentPair = {
  view: DailyScanTimesDashboardComponent,
  form: DailyScanTimesDashboardFormComponent,
};
